import {
  Destination,
  DestinationAction,
  RawDestination
} from '../../shared/interfaces/destination';
import { DestinationFactory } from '../DestinationList/factories/destinationFactory';
import { EntityActions } from '../../entity-actions/EntityActions';
import { DESTINATION_ACTIONS_CONFIRMATION_DIALOG_PROPS } from './constant/destination-actions-confirm-dialog-props';

interface DestinationActionsProps {
  destination: Destination;
}

export function DestinationActions({ destination }: DestinationActionsProps) {
  return (
    <EntityActions<DestinationAction, Destination>
      actions={destination.actions}
      entity={destination}
      confirmationDialogProps={DESTINATION_ACTIONS_CONFIRMATION_DIALOG_PROPS}
      getEntityFromActionResponse={res => DestinationFactory(res as RawDestination)}
      menuLabel='Destination Actions'
    />
  );
}
